import { useState } from "react";
import {
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  Label,
  Row,
  Col,
} from "reactstrap";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import FileSaver from "file-saver";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { downloadManufacturalJournalReportsApi} from "../../../../apis/invoiceGenerationApis";
import {  DownloadManufacturalJournalReportType} from "../../../../commonTypes/invoiceGenerationTypes";
import { Loader} from "../../../commons";
import { NewDownloadIcon, NewDownloadIconActive } from "../../../../assets/images";
import { CalenderIcon } from "../../../Icon";


type AppProps = {
  clientCode: number;
  token: string | null;

};

const DownloadManufacturalJournalReport = ({
  clientCode,
  token,
}: AppProps) => {
  const [showDropdown, setShowDropdown] = useState<boolean>(false);
  const [startDate, setStartDate] = useState<any>(null);
  const [endDate, setEndDate] = useState<any>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);


  const toggleShowDropdown = () => {
    setShowDropdown(!showDropdown);
    //handleDateSelect();
  };

  const handleCancel = () => {
    setStartDate(null);
    setEndDate(null);
    setShowDropdown(!showDropdown);
  };

  const handleStartDate = (date: any) => {
    setStartDate(date);
    setEndDate(null);
  };

  const handleDownload = () => {
    setIsLoading(true);
    setShowDropdown(false);
    handlePrepareManufacturalJournalReportData();

  };
  const handlePrepareManufacturalJournalReportData =() => {
    let params: DownloadManufacturalJournalReportType = {
        start_date: moment(startDate).format("DD-MM-YYYY"),
        end_date: moment(endDate).format("DD-MM-YYYY"),
        client_code: clientCode,
        token,
    };
    if(params && token) {
        handleDownloadManufacturalJournalReport(params);
    }
    setStartDate(null);
    setEndDate(null);
  };

  const handleDownloadManufacturalJournalReport = (params: any) => {
    let reportName = `manufacturing_journal_of_${clientCode || "-" }_${moment(startDate).format("DD-MM-YYYY")}_To_${moment(endDate).format("DD-MM-YYYY")}.xlsx`;

    downloadManufacturalJournalReportsApi(params).then((response) => {
        setIsLoading(false);
        let blob = new Blob([response.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
        FileSaver.saveAs(blob, reportName);
    });
  };
 

  return (
    <>
      <ButtonDropdown
        isOpen={showDropdown}
        toggle={toggleShowDropdown}
        className="download-report-btn"
        style={
          showDropdown
            ? {
                color: "#dd4433",
                backgroundColor: "#fff6f5",
              }
            : {}
        }
      >
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 250 }}
          overlay={
            <Tooltip id="button-view-download-invoice">
              Download Reports
            </Tooltip>
          }
        >
          <DropdownToggle
            caret
            outline
            style={
              showDropdown
                ? {
                    color: "#dd4433",
                    backgroundColor: "#fff6f5",
                  }
                : { border: "1px solid#bfcbe1" }
            }
          >
            {/* <DownloadIcon />  */}
            <img
              src={showDropdown ? NewDownloadIconActive : NewDownloadIcon}
              alt="download icon"
            />
          </DropdownToggle>
        </OverlayTrigger>
        <DropdownMenu right>
          <div className="download-dropdown p-3">
            <h4>Download Report</h4>

            <Row>
              <Col md={6} className="form-group">
                <div>Start Date </div>
                <Row>
                  <Col md="12" className="download-report-picker">
                    <Label className="m-0 p-0">
                      <span className="calender-icon">
                        <CalenderIcon />
                      </span>
                      <DatePicker
                        dateFormat="dd-MM-yyyy"
                        selected={startDate}
                        onChange={handleStartDate}
                        selectsStart
                        showMonthDropdown
                        showYearDropdown
                        startDate={startDate}
                        endDate={endDate}
                        className="form-control"
                      />
                    </Label>
                  </Col>
                </Row>
              </Col>
              <Col md={6} className="form-group">
                <div>End Date</div>
                <Row>
                  <Col md="12" className="download-report-picker">
                    <Label className="m-0 p-0">
                      <span className="calender-icon">
                        <CalenderIcon />
                      </span>
                      <DatePicker
                        dateFormat="dd-MM-yyyy"
                        selected={endDate}
                        onChange={(date: any) => setEndDate(date)}
                        selectsEnd
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        startDate={startDate}
                        endDate={endDate}
                        minDate={startDate}
                        className="form-control"
                      />
                    </Label>
                  </Col>
                </Row>
              </Col>
              <Col md={12} className="text-right">
                <button
                  className="btn btn-outline-secondary mr-3"
                  onClick={handleCancel}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-primary"
                  onClick={handleDownload}
                  disabled={!startDate || !endDate}
                >
                  Download
                </button>
              </Col>
            </Row>
          </div>
        </DropdownMenu>
      </ButtonDropdown>
      {isLoading && <Loader />}
    </>
  );
};

export default DownloadManufacturalJournalReport;
